// src/hooks/useLanguage.js
import { useEffect, useState } from 'react';

const useLanguage = () => {
  const [isEnglish, setIsEnglish] = useState(false);

  useEffect(() => {
    const currentPath =
      typeof window !== 'undefined' ? window.location.pathname : '';
    setIsEnglish(currentPath.includes('/en/'));
  }, []);

  return isEnglish;
};

export default useLanguage;
